/**
 * Mantine следует за темой приложения: поповеры, модалки и поля Mantine
 * перекрашиваются вместе с остальным интерфейсом, откуда бы тему ни
 * переключили — из шапки или из профиля.
 */

import { useMantineColorScheme } from '@mantine/core';
import { useEffect } from 'react';

import { useThemeStore } from '../store/themeStore';

export function useMantineThemeSync(): void {
  const mode = useThemeStore((state) => state.mode);
  const { setColorScheme } = useMantineColorScheme();
  useEffect(() => {
    setColorScheme(mode);
  }, [mode, setColorScheme]);
}
